import { format as d3Format } from "d3-format"
import { useEffect, useState }  from "react"
import {
	Legend,
	Line,
	LineChart,
	ReferenceLine,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts"
import * as globals from "../../globals"
// import { actionCreators as forecastActionCreators } from "../../store/Forecast.ts"
import * as debounce from "../../utils/debounce"
import * as selectionHelper from "../../utils/selectionHelper"
import { CardLoading } from "../card/CardLoading"
import { FilterChooser } from "../filter/FilterChooser"
import { ProductBlockMini } from "../product-drawer/ProductBlockMini"
import CustomLegend from "../common/CustomLegend"
import CustomizedTick from "../common/CustomizedTick"


export function demandCurves(props) {

    //props = {
    //prod:, 
    //filter: , 
    //att: ,
    //metric: { name: 'share', format: '.2%' },
    //data: [{},{}]
    //}








	// const [metric, setMetric] = useState('share')

	// // these are needed from parent state
	// static inheritOptions = ["configEtag"]

	// static scenarioDriven = true

	// returns widget's local settings (for save state)
	// const getSaveState = () => {
	// 	const selectedProductId = props.selectedProductId
	// 	if (!selectedProductId) return null

	// 	const filter =
	// 		props.filter || globals.getDefaultFilter(props.study)

	// 	// get the data
	// 	const fullCache = props.fullCache
	// 	const key = `${filter.syntax}:curves:${props.att}:${selectedProductId}`
	// 	console.log('key', key)
	// 	const data = fullCache?.[key]

	// 	return {
	// 		selectedProductId,
	// 		filter,
	// 		metric: props.metric || state.metric,
	// 		data: data,
	// 	}
	// }
	

	// const refreshIfNeeded = debounce.debounce(() => {
		

	// 	// cancel if no selection
	// 	const selectedProductId = props.selectedProductId
	// 	if (!selectedProductId) return

	// 	// cancel if config isn't ready
	// 	if (!props.etag) return

	// 	const filter = props?.filter

	// 	// cancel if cached data already exists, with matching filter and etag
	// 	let data = props.data
	// 	// if (!data) {
	// 	// 	const fullCache = state.fullCache//props.fullCache
	// 	// 	console.log('%cfullCache', 'background: pink', fullCache)
	// 	// 	const key = `${filter.syntax}:curves:${props.att}:${selectedProductId}`
	// 	// 	data = fullCache?.[key]
	// 	// }

	// 	// if (data && data.etag === props.etag) return

	// 	// cancel if cached data is loading
	// 	if (data && data.loading) return

	// 	// refresh is needed. request it.
	// 	// props.requestAux(
	// 	// 	"curves",
	// 	// 	filter.syntax,
	// 	// 	`curves:${props.att}:${selectedProductId}`,
	// 	// 	{
	// 	// 		target_product: selectedProductId,
	// 	// 		target_attribute: props.att,
	// 	// 	},
	// 	// )
    // }, debounce.forecastDelay)
    
    // const refresh = () => {
	// 	refreshIfNeeded()
    // }
    
        // const selectedProductId = props.prodId
		// const selectedProduct = selectedProductId
		// 	? selectionHelper.getSelectionInfo(
		// 			"product",
		// 			selectedProductId,
		// 			props.study,
		// 			props.selections?.hierarchy,
		// 	  )
		// 	: null
        const prod = props.prod
		const filter = props.filter
		const att = props.att
		// const att = props.atts?.find(
		// 	(a) => a.name === attName,
		// )

		if (!att)
			return <div><center>{`att ${att?.name} missing`}</center></div>
		
		// const attFormat = d3Format(att.format || '$.0f')

		let data = props.data


		// if (!data) {
		// 	const fullCache = state.fullCache //props.fullCache
		// 	const key = `${filter.syntax}:curves:${props.att}:${selectedProductId}`
		// 	console.log('fullCache', fullCache)
		// 	console.log('key', key)
		// 	data = fullCache?.[key]
		// }
		// console.log('data', data)

		// let cacheValue = data?.value

		// let data = cacheValue.data 
		// if (cacheValue) {
		// 	data = (cacheValue.data || []).map((el) => ({
		// 		[attName]: el[attName],
		// 		...el[selectedProductId],
		// 	}))
		// 	console.log('%cdata','background:pink', data)
		// 	//.filter((el, idx) => idx < 20)
		// }

    const selMetric = props.metric || { name: 'share', format: '.2%' }// metrics.find((m) => m.key === state.metric)

    const maxEntry = data
        ? data.reduce((acc, el) => {
                if (!acc.max || acc.max < el['value']) {
                    return {
                        max: el['value'],
                        input: el['name'],
                    }
                } else return acc
            }, {})
        : null
    const maxInput = maxEntry ? maxEntry.input : null
    const maxOutput = maxEntry ? maxEntry.max : null

    console.log('maxInput', maxInput);
    console.log('maxOutput', maxOutput);

    // const filterCache = (data || {})[filter.syntax]
    // let productCache = (filterCache || {})[props.selectedItem]

    // const expired =	props.inDataCard && props.etag !== (data || {}).etag
    // const loading = data && data.loading
    // if (props.loaded && typeof props.loaded === "function")
    // 	props.loaded(!loading)

    const format = d3Format(selMetric?.format)
    // if (props.getJSONData && typeof props.getJSONData === "function")
    // 	props.getJSONData(data)

    const renderTick = (e) => {
        let customVal = {
            ...e,
            payload: { ...e.payload, value: format(e.payload.value) },
        }
        return <CustomizedTick {...customVal} />
    }
		
    

    return (
        
                <ResponsiveContainer >
                    <LineChart data={data} margin={{ top: 10, right: 40, left: 20, bottom: 10 }}>
                        <XAxis
                            dataKey={'name'}
                            type="category"
                            label={{ value: att.label, position: 'insideBottom', offset: 0 }}
                        />
                        <YAxis
                            type="number"
                            tickFormatter={format}
                            tick={renderTick}
                            label={{ value: selMetric.label, angle: -90, position: 'insideLeft' }}
                        />
                        <Tooltip formatter={format} />
                        {/* <Legend
                            verticalAlign="bottom" 
                            align="center" 
                            layout="horizontal" 
                            wrapperStyle={{ paddingTop: 20 }} 
                        /> */}
                        <ReferenceLine
                            x={maxInput}
                            stroke="red"
                            xlabel={`Max ${att.label}: ${maxInput}`}
                        />
                        <ReferenceLine
                            y={maxOutput}
                            stroke="#cfcfcf"
                            strokeDasharray="3 3"
                            label={`Max ${selMetric?.label}: ${format(maxOutput)}`}
                        />
                        <Line
                            type="monotone"
                            dataKey={'value'}//selMetric?.key}
                            name={selMetric?.label}
                            stroke={props.color || '#0064c8'}
                            dot={false}
                            activeDot={{ r: 4 }}
                        />
                    </LineChart>
                </ResponsiveContainer>				
		
    )
}


